export default {
  mounted(el, binding) {
    if (typeof binding.value === 'function') {
      binding.value(el, binding);
    }
  },
};
